var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loto"},[_c('Banner',{attrs:{"class-banner":'banner-loto'}}),_c('SectionPickTabs'),_c('Information')],1)}
var staticRenderFns = []

export { render, staticRenderFns }